export default __webpack_public_path__ + "static/media/google.5f74ccd3.svg";